import { isAndroid } from './deviceUtils';

export const testIdentifiers = (testid: string) => {
  if (process.env.JEST_WORKER_ID) {
    return { testID: testid };
  } else if (isAndroid) {
    return {
      testID: testid,
      // accessibilityLabel: testid,
      //accessible: true,
    };
  } else {
    return { testID: testid };
  }
};
